import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import InfiniteLoading from 'vue-infinite-loading';
import axios from 'axios'

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.component('infinite-loading', InfiniteLoading);

// Axios 請求攔截器 - 自動加入 Authorization header
axios.interceptors.request.use(config => {
  const mackay = JSON.parse(localStorage.getItem('mackay') || '{}')
  if (mackay.access_token) {
    config.headers.Authorization = `Bearer ${mackay.access_token}`
  }
  return config
})

// Axios 回應攔截器 - Token 過期時強制登出
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Token 過期或無效，清除登入狀態並跳轉到登入頁
      localStorage.removeItem('mackay')
      alert('Your session has expired. Please log in again.')
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

import { mapGetters, mapMutations } from 'vuex';
// jwt_decode 已移除：現在使用者資訊直接從後端 API 回傳

const VUEX_FEATURE = {
  data: () => ({
    SERVER_PATH: process.env.VUE_APP_SERVER_PATH,
    VUE_PATH: process.env.VUE_APP_PATH,
    IMG_PATH: process.env.VUE_APP_IMG_PATH,
    LINE_ID: process.env.VUE_APP_LINE_ID,
    LINE_SECRET: process.env.VUE_APP_LINE_SECRET,
    LINE_CALLBACK: process.env.VUE_APP_LINE_CALLBACK,
    GOOGLE_ID: process.env.VUE_APP_GOOGLE_ID,
    GOOGLE_CALLBACK: process.env.VUE_APP_GOOGLE_CALLBACK,
    PATH_CHECK: process.env.VUE_APP_LOGIN_CHECK,
  }),

  methods: {
    ...mapMutations({
      updateUserProfile: 'UPDATE_USER_PROFILE',
      updateUserLogin: 'UPDATE_USER_LOGIN',
      updateUserId: 'UPDATE_USER_ID',
      updateChatRoom: 'UPDATE_CHAT_ROOM',
      updateAlert: 'UPDATE_ALERT',
      updateRwdType: 'UPDATE_RWD_TYPE',
    }),
    autoRelogin() {
      const mackayData = localStorage.getItem('mackay');

      if (!mackayData) {
        this.updateUserProfile(null);
        this.updateUserId(null);
        this.updateUserLogin(false);
        const urlObj = new URL(location.href);
        if (urlObj.pathname !== '/') {
          this.$router.push('/');
        }
        return;
      }

      const getDataJson = JSON.parse(mackayData)
      console.log('Check localStorage', getDataJson)

      // 檢查是否有 access_token
      if (getDataJson.access_token) {
        const USER_PROFILE = {
          name: getDataJson.name || 'User',
          line_id: getDataJson.user_id,
          thumb: getDataJson.avatar || '',
          id: getDataJson.user_id,
          super_user: getDataJson.super_user,
          room_path: getDataJson.room_path,
          user_lang: getDataJson.user_lang,
          points_balance: getDataJson.points_balance || 0,
          is_first_question: getDataJson.is_first_question !== undefined ? getDataJson.is_first_question : true
        }

        console.log('autoRelogin', USER_PROFILE);

        this.updateUserLogin(true);
        this.updateUserProfile(USER_PROFILE);
        // this.updateUserId(USER_PROFILE.id);
        // if (USER_PROFILE) {
        //   this.updateUserId(USER_PROFILE.id);
        // }
        this.updateAlert({
          show: true,
          status: 'success',
          message: 'Login ok!'
        });
      } else {
        // 沒有 access_token，清除登入狀態
        this.updateUserProfile(null);
        this.updateUserId(null);
        this.updateUserLogin(false);
        localStorage.removeItem('mackay');
        const urlObj = new URL(location.href);
        if (urlObj.pathname !== '/') {
          this.$router.push('/');
        }
      }
    },

    routerRedirectTo404() {
      this.$router.push({ name: 'error404' });
    },

    // showAlertBlock(status) {
    //   this.alertShow = true;
    //   this.alertStatus = status;

    //   console.log('RUN ALERT: ', status, this.alertShow, this.alertStatus);
    //   // setTimeout(() => {
    //   //   this.alertShow = false;
    //   // }, 5000);
    // },

    userLoginProcess(code, state, recaptcha_token) {
      axios.post(`${this.SERVER_PATH}api/member/line_login`, { code, state, recaptcha_token })
        .then((res) => {
          const getAccessToken = res.data.access_token;

          if (getAccessToken) {
            console.log('Access Token received')
            const localStorageSaveObj = {
              access_token: getAccessToken,
              refresh_token: res.data.refresh_token,
              user_id: res.data.user_id,
              super_user: res.data.super_user,
              user_lang: res.data.user_lang,
              room_path: res.data.room_path,
              points_balance: res.data.points_balance || 0,
              is_first_question: res.data.is_first_question !== undefined ? res.data.is_first_question : true,
              name: res.data.name || 'User',
              avatar: res.data.avatar || ''
            };

            localStorage.setItem('mackay', JSON.stringify(localStorageSaveObj));

            // 從 API 回應取得使用者資訊
            const USER_PROFILE = {
              name: res.data.name || 'User',
              line_id: res.data.user_id,
              thumb: res.data.avatar || '',
              id: res.data.user_id,
              super_user: res.data.super_user,
              user_lang: res.data.user_lang,
              room_path: res.data.room_path,
              points_balance: res.data.points_balance || 0,
              is_first_question: res.data.is_first_question !== undefined ? res.data.is_first_question : true
            }

            this.updateUserProfile(USER_PROFILE);
            this.updateUserId(USER_PROFILE.id);
            this.updateUserLogin(true);
            this.updateAlert({
              show: true,
              status: 'success',
              message: 'Login ok!'
            });

            console.log('LOGIN STATUS: ', this.userLogin);
            console.log('USER_PROFILE: ', USER_PROFILE);
            // localStorage.setItem('userId', USER_PROFILE.id);  
            // localStorage.setItem('userName', USER_PROFILE.name);
            // localStorage.setItem('userThumb', USER_PROFILE.thumb);
            // this.showAlertBlock('success');
          }

          // this.$router.push({name: 'chat-list'});
          if (res.data.super_user == true) {
            this.$router.push('/chat');
          } else {
            this.$router.push('/chat/' + res.data.room_path);
          }

        })
        .catch((err) => {
          console.error('LINE LOGIN Failed:', err);
          this.updateUserProfile({});
          this.updateUserId('');
          this.updateUserLogin(false);
          this.updateAlert({
            show: true,
            status: 'error',
            message: 'Please log in again!'
          });
          localStorage.removeItem('mackay');
          this.$router.push('/500');
        });

      return true;
    },

    googleLoginProcess(code, state, recaptcha_token) {
      axios.post(`${this.SERVER_PATH}api/member/google_login`, { code, state, recaptcha_token })
        .then((res) => {
          const getAccessToken = res.data.access_token;

          if (getAccessToken) {
            console.log('Google Access Token received')
            const localStorageSaveObj = {
              access_token: getAccessToken,
              refresh_token: res.data.refresh_token,
              user_id: res.data.user_id,
              super_user: res.data.super_user,
              user_lang: res.data.user_lang,
              room_path: res.data.room_path,
              points_balance: res.data.points_balance || 0,
              is_first_question: res.data.is_first_question !== undefined ? res.data.is_first_question : true,
              name: res.data.name || 'User',
              avatar: res.data.avatar || ''
            };

            localStorage.setItem('mackay', JSON.stringify(localStorageSaveObj));

            // 從 API 回應取得使用者資訊
            const USER_PROFILE = {
              name: res.data.name || 'User',
              google_id: res.data.user_id,
              thumb: res.data.avatar || '',
              id: res.data.user_id,
              super_user: res.data.super_user,
              user_lang: res.data.user_lang,
              room_path: res.data.room_path,
              points_balance: res.data.points_balance || 0,
              is_first_question: res.data.is_first_question !== undefined ? res.data.is_first_question : true
            }

            this.updateUserProfile(USER_PROFILE);
            this.updateUserId(USER_PROFILE.id);
            this.updateUserLogin(true);
            this.updateAlert({
              show: true,
              status: 'success',
              message: 'Google Login ok!'
            });

            console.log('GOOGLE LOGIN STATUS: ', this.userLogin);
            console.log('GOOGLE USER_PROFILE: ', USER_PROFILE);
          }

          if (res.data.super_user == true) {
            this.$router.push('/chat');
          } else {
            this.$router.push('/chat/' + res.data.room_path);
          }

        })
        .catch((err) => {
          console.error('GOOGLE LOGIN Failed:', err);
          this.updateUserProfile({});
          this.updateUserId('');
          this.updateUserLogin(false);
          this.updateAlert({
            show: true,
            status: 'error',
            message: 'Google Login Failed!'
          });
          localStorage.removeItem('mackay');
          this.$router.push('/500');
        });

      return true;
    },

    logout() {
      localStorage.removeItem('mackay');

      this.updateAlert({
        show: true,
        status: 'success',
        message: 'Logged out ok!'
      });
      setTimeout(() => {
        this.$router.push('/');
      }, 1000);
    },

  },

  computed: {
    ...mapGetters({
      userProfile: 'exportUserProfile',
      userLogin: 'exportUserLogin',
      storeUserId: 'exportUserId',
      storeChatRoom: 'exportChatRoom',
      alert: 'exportAlert',
      getRwdType: 'exportRwdType',
    }),
  },
}

Vue.mixin(VUEX_FEATURE);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
